'use strict';

module.exports = {
    syncLoginFromTouch: {
        hy: {
            key: 'syncLoginFromTouch'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/login.js
// module id = 12
// module chunks = 0 2 4